import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

export const Create = createAsyncThunk(
  "autho/registration",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Autho.Registration, data);
      return res; // The new country object
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// GET Auth - Login
export const GETUser = createAsyncThunk(
  "autho/get-user",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(APIS.Autho.GETUser);
      return res;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const Update_User = createAsyncThunk(
  "autho/profileedit",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(APIS.Autho.Update_User, data);

      if (response?.success) {
        return response;
      }
      return rejectWithValue(response);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "registration",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,

    getUserData: null,
    getUserStatus: IDS.SLICESTATUS.Idle,
    getUserError: null,

    updateUserStatus: IDS.SLICESTATUS.Idle,
    updateUserError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GETUser.pending, (state) => {
        state.getUserStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(GETUser.fulfilled, (state, action) => {
        state.getUserStatus = IDS.SLICESTATUS.Succeeded;
        state.getUserData = action.payload?.data || null;
      })
      .addCase(GETUser.rejected, (state, action) => {
        state.getUserStatus = IDS.SLICESTATUS.Failed;
        state.getUserError = action.payload;
      })

      .addCase(Update_User.pending, (state) => {
        state.updateUserStatus = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update_User.fulfilled, (state, action) => {
        state.updateUserStatus = IDS.SLICESTATUS.Succeeded;
        state.getUserData = {
          ...state.getUserData,
          ...action.payload?.data,
        };
      })
      .addCase(Update_User.rejected, (state, action) => {
        state.updateUserStatus = IDS.SLICESTATUS.Failed;
        state.updateUserError = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
